import home from './home';
import prompts from './prompts';
import story from './story';
import startStory from './start-story';
import subrosa from './subrosa';

export default [home, prompts, story, startStory, subrosa];
